import {AttributeHistoryRule} from './types';

export const validateAttributeHistoryRule = <
	T extends AttributeHistoryRule = AttributeHistoryRule,
>(
	rule: T,
) => {
	return true;
};

export default validateAttributeHistoryRule;
